import React from 'react';
import { FileText } from 'lucide-react';
import type { SettingsSectionItem } from '~/libraries/settings/SettingsSection';
import { LibrarySection } from '../shared/LibrarySection';
import { useNavigate } from 'react-router-dom';
import { InsuranceProviderTable } from './InsuranceProviderTable';
import { PageLayout } from '~/shared/PageLayout';

export const InsuranceProviderLibrarySection = {
	settingsView: 'insurance',
	title: 'Insurance Providers',
	description: 'Manage insurance companies and payer information',
	TitleIcon: FileText
} satisfies SettingsSectionItem;

export function InsuranceProviderLibrary() {
	const navigate = useNavigate();
	const handleAdd = () => {
		navigate('add');
	};

	return (
		<PageLayout
			pageHeader={{
				title: InsuranceProviderLibrarySection.title,
				description: InsuranceProviderLibrarySection.description,
				TitleIcon: InsuranceProviderLibrarySection.TitleIcon
			}}
		>
			<LibrarySection
				librarySection={InsuranceProviderLibrarySection}
				searchPlaceholder="Search insurance providers by name, city, or address..."
				noResultsLabel="No Insurance Providers Found"
				noResultsSubLabel="Intervention definitions are seeded from configuration files"
				TableComponent={InsuranceProviderTable}
			/>
		</PageLayout>
	);
}
